// extracted by mini-css-extract-plugin
export default {"header":"Header_header__UTGox","menu":"Header_menu__+-txP","logo":"Header_logo__qji5D","inform":"Header_inform__njd2S","link":"Header_link__MmlaC"};